/* Adds accessible mobile navigation only to four benefit blocks on the homepage. */
(function(){
 function setup(){
  if(!document.body || !document.body.classList) return;
  var section=document.querySelector('[id*="__section_16"]');
  if(!section || section.querySelector('.mito-benefits-controls')) return;
  var candidates=section.querySelectorAll('.group-block-content');
  var track=Array.from(candidates).find(function(el){
    return el.children.length===4 && Array.from(el.children).every(function(child){return child.classList.contains('group-block')});
  });
  if(!track)return;
  track.classList.add('mito-benefits-track');
  track.setAttribute('aria-label','Voordelen van Mito Thee');
  var controls=document.createElement('div');controls.className='mito-benefits-controls';
  var prev=document.createElement('button');prev.type='button';prev.textContent='‹';prev.setAttribute('aria-label','Vorig voordeel');
  var pos=document.createElement('span');pos.className='mito-benefits-position';pos.setAttribute('aria-live','polite');
  var next=document.createElement('button');next.type='button';next.textContent='›';next.setAttribute('aria-label','Volgend voordeel');
  controls.append(prev,pos,next);track.parentElement.appendChild(controls);
  function index(){return track.clientWidth?Math.min(3,Math.max(0,Math.round(track.scrollLeft/track.clientWidth))):0}
  function update(){var i=index();pos.textContent=(i+1)+' / 4';prev.disabled=i===0;next.disabled=i===3;controls.style.display=window.matchMedia('(max-width:749px)').matches?'flex':'none'}
  function go(step){var i=Math.min(3,Math.max(0,index()+step));track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});setTimeout(update,360)}
  prev.addEventListener('click',function(){go(-1)});next.addEventListener('click',function(){go(1)});
  track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();
